// recommendations-add-cart.js
class RecommendationsAddToCart {
  constructor() {
  this.currentLanguage = document.documentElement.lang || 
                        (window.Shopify && window.Shopify.locale ? 
                         window.Shopify.locale.split('-')[0] : 'en');
  
  // Define translations
  this.translations = {
    en: {
      add_to_cart: 'Add to Cart',
      adding: 'Adding...',
      added: 'Added!',
      added_success: 'Added to cart!',
      error_message: 'Could not add to cart. Please try again.'
    },
    lv: {
      add_to_cart: 'Pievienot grozam',
      adding: 'Pievieno...',
      added: 'Pievienots!',
      added_success: 'Pievienots grozam!',
      error_message: 'Nevarēja pievienot grozam. Lūdzu, mēģiniet vēlreiz.'
    }
  };
    this.init();
  }

  updateCartCount() {
  // Fetch the latest cart data
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const itemCount = cart.item_count;
      
      // Update ALL cart count elements
      const cartCountElements = document.querySelectorAll('cart-count, [data-cart-count], .cart-count');
      
      cartCountElements.forEach(element => {
        // Update the text content
        element.textContent = itemCount > 99 ? '99+' : itemCount;
        
        // Update aria-label for accessibility
        const ariaLabel = itemCount === 1 ? 
          '{{ "general.cart.cart_count.one" | t }}' : 
          '{{ "general.cart.cart_count.other" | t: count: itemCount }}';
        element.setAttribute('aria-label', ariaLabel);
        
        // Show/hide based on cart count
        if (itemCount === 0) {
          element.style.display = 'none';
          element.setAttribute('hidden', true);
        } else {
          element.style.display = '';
          element.removeAttribute('hidden');
        }
      });
      
      // Also update any cart count bubbles or badges
      const cartBubbles = document.querySelectorAll('.cart-count-bubble, .cart-bubble');
      cartBubbles.forEach(bubble => {
        const countElement = bubble.querySelector('span, .count');
        if (countElement) {
          countElement.textContent = itemCount > 99 ? '99+' : itemCount;
        }
      });
      
    })
    .catch(error => console.error('Error updating cart count:', error));
}

  init() {
    //console.log('🛒 Quick Add Recommendations: Initializing...');
    this.setupEventListeners();
  }

  setupEventListeners() {
    // Use event delegation for dynamically added buttons
    document.addEventListener('click', (e) => {
      const addButton = e.target.closest('.add-recommendation-to-cart');
      if (addButton) {
        e.preventDefault();
        e.stopPropagation();
        this.handleAddToCart(addButton);
      }

            // ALSO handle the close button with event delegation
      const closeButton = e.target.closest('.drawer__close-btn');
      if (closeButton && closeButton.hasAttribute('aria-controls')) {
        this.handleCloseButton(closeButton);
      }
    });
  }

  async handleAddToCart(button) {
    const productId = button.dataset.productId;
    const variantId = Number(button.dataset.variantId);
    if (!variantId) return;
    const recommendationElement = button.closest(`[data-recommendation-id="${productId}"]`);

    if (!variantId) {
      console.error('No variant ID found');
      return;
    }

    // Show loading state
    this.setButtonLoading(button, true);

  try {
    // Add item to cart using Shopify's AJAX API
    await this.addToCart(variantId);
    
    // Remove the recommendation from view with animation
    if (recommendationElement) {
      this.removeRecommendation(recommendationElement);
    }
    
    // CRITICAL: Dispatch cart update event for theme to handle
    // Try multiple events to ensure cart updates
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    
    // Manually update the cart count since the theme's handler has an error
    this.updateCartCount();
    
    // Show success feedback
    const langTranslations = this.translations[this.currentLanguage] || this.translations.en;
    this.showSuccessMessage(langTranslations.added_success);
    
  } catch (error) {
    console.error('Error adding to cart:', error);
    this.showErrorMessage(langTranslations.error_message);
  } finally {
    this.setButtonLoading(button, false);
  }
}

  async addToCart(variantId) {
    const formData = {
      items: [{ 
        id: variantId, 
        quantity: 1 
      }]
    };
    
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(formData)
    });
    
    if (!response.ok) {
      throw new Error('Failed to add item to cart');
    }
    
    return await response.json();
  }

  removeRecommendation(element) {
    if (element) {
      // Smooth fade out animation
      element.style.transition = 'opacity 0.3s ease, height 0.3s ease, margin 0.3s ease, padding 0.3s ease';
      element.style.opacity = '0';
      element.style.height = element.offsetHeight + 'px';
      
      // Force reflow
      element.offsetHeight;
      
      element.style.height = '0';
      element.style.margin = '0';
      element.style.padding = '0';
      element.style.overflow = 'hidden';
      
      setTimeout(() => {
        element.style.display = 'none';
        
        // Update swiper/carousel if present
        const swiper = element.closest('.swiper')?.swiper;
        if (swiper) {
          setTimeout(() => swiper.update(), 100);
        }
      }, 300);
    }
  }

setButtonLoading(button, isLoading) {
  const btnText = button.querySelector('.btn__text');
  
  // Get the correct language translations
  const langTranslations = this.translations[this.currentLanguage] || this.translations.en;
  
  // Get translations from data attributes OR from our translation object
  // The data attributes should already have the correct translations from Liquid
  const addText = button.getAttribute('data-i18n-add') || langTranslations.add_to_cart;
  const addingText = button.getAttribute('data-i18n-adding') || langTranslations.adding;
  const addedText = button.getAttribute('data-i18n-added') || langTranslations.added;
  
  if (isLoading) {

    button.disabled = true;

  } else {

    button.disabled = false;

    
    // Reset after 2 seconds
    setTimeout(() => {
      button.classList.remove('added');
      if (btnText) {
        btnText.textContent = addText;
      }
    }, 2000);
  }
}

  showSuccessMessage(text) {
    // Create toast notification
    const toast = document.createElement('div');
    toast.className = 'cart-toast success';
    toast.textContent = text;
    toast.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #10B981;
      color: white;
      padding: 12px 20px;
      border-radius: 4px;
      z-index: 9999;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      animation: toastSlideIn 0.3s ease forwards;
    `;
    
    document.body.appendChild(toast);
    
    // Add CSS animation if not already present
    if (!document.querySelector('#toast-animations')) {
      const style = document.createElement('style');
      style.id = 'toast-animations';
      style.textContent = `
        @keyframes toastSlideIn {
          from {
            transform: translateX(100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
        
        @keyframes toastSlideOut {
          from {
            transform: translateX(0);
            opacity: 1;
          }
          to {
            transform: translateX(100%);
            opacity: 0;
          }
        }
      `;
      document.head.appendChild(style);
    }
    
    // Remove toast after delay
    setTimeout(() => {
      toast.style.animation = 'toastSlideOut 0.3s ease forwards';
      setTimeout(() => toast.remove(), 300);
    }, 2000);
  }

  showErrorMessage(text) {
    const toast = document.createElement('div');
    toast.className = 'cart-toast error';
    toast.textContent = text;
    toast.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #EF4444;
      color: white;
      padding: 12px 20px;
      border-radius: 4px;
      z-index: 9999;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      animation: toastSlideIn 0.3s ease forwards;
    `;
    
    document.body.appendChild(toast);
    
    setTimeout(() => {
      toast.style.animation = 'toastSlideOut 0.3s ease forwards';
      setTimeout(() => toast.remove(), 300);
    }, 3000);
  }


  handleCloseButton(button) {
    const drawerId = button.getAttribute('aria-controls');
    const drawer = document.getElementById(drawerId);
    
    if (drawer) {
      // Use the theme's method to close the drawer if it exists
      if (typeof window.CartDrawer !== 'undefined' && window.CartDrawer.closeDrawer) {
        window.CartDrawer.closeDrawer();
      } 
      // Or manually close it
      else if (drawer.hasAttribute('open')) {
        drawer.removeAttribute('open');
        document.body.style.overflow = ''; // Reset body overflow
      }
      
      // Dispatch close event
      drawer.dispatchEvent(new CustomEvent('drawer:close'));
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  // Small delay to ensure theme is loaded
  setTimeout(() => {
    window.quickAddRecommendations = new RecommendationsAddToCart();
    //console.log('🛒 Quick Add Recommendations: Ready');
  }, 500);
});

// Re-initialize on dynamic content loads (Turbo/Turbolinks)
if (typeof Turbo !== 'undefined') {
  document.addEventListener('turbo:load', () => {
    if (!window.quickAddRecommendations) {
      window.quickAddRecommendations = new RecommendationsAddToCart();
    }
  });
}

// Manual initialization function
window.initQuickAddRecommendations = function() {
  window.quickAddRecommendations = new RecommendationsAddToCart();
  return window.quickAddRecommendations;
};

// Debug helper
window.debugQuickAdd = function() {
  //console.log('🛒 Quick Add Debug Info:');
  //console.log('- Instance:', window.quickAddRecommendations);
  //console.log('- Buttons found:', document.querySelectorAll('.add-recommendation-to-cart').length);
  
  const buttons = document.querySelectorAll('.add-recommendation-to-cart');
  buttons.forEach((btn, i) => {
    console.log(`Button ${i + 1}:`, {
      productId: btn.dataset.productId,
      variantId: btn.dataset.variantId,
      text: btn.textContent.trim()
    });
  });
};